import { connect } from 'react-redux';
import {
    actions
} from '../../../../../redux/modules/itinerarios/itinerarios';
import NuevaFactura from './facturas';

const mstp = state => {
    return {...state.itinerario}
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(NuevaFactura)
